<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Fitter hours was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Fitter Hours - {{ this.fitterHours.fitter.firstName }} {{ this.fitterHours.fitter.lastName }} for {{ this.fitterHours.date }}</h1>
    <app-audit-line [data]='this.fitterHours'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-fitter-hours-form [fitterHours]='this.fitterHours'></app-fitter-hours-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/4workshop/fitters/hours/advanced'>Cancel</button>
    </form>
  </div>
</div>
